import React, { useState } from "react";
import MainButtonsContainer from "features/FolderManager/components/MainButtonsContainer";
import { Grid, Icon, Message, Popup, Label, Header, Loader } from "semantic-ui-react";
import { displayGender } from "utils/displayGender";
import displayName from "utils/displayName";
import WhiteButtonEditBloc from "components/Buttons/WhiteButtonEditBloc";
import EditPatient from "features/FolderManager/components/SidebarComp/EditPatient";
import ContainerField from "components/ContainerField";
import moment from "moment";
import { formatPhoneNumberToInternational, checkPrefixePhoneNumer } from "utils/phone";
import { capitalize } from "utils/patientConverter";
import ChangePatientModal from "../modals/ChangePatientModal";
import ManagePatientExpressModal from "../modals/ManagePatientExpressModal";
import AddPatient from "features/FoldersOverview/components/Sidebar/AddPatient";
import { toast } from "react-toastify";

const styles = {
	mainContainer: {
		backgroundColor: "rgb(1, 111, 97)",
		color: "#fff",
		padding: 10,
		borderRadius: "4px",
		border: "1px solid rgb(1, 111, 97)",
		boxShadow: "0px 9px 20px -23px rgba(148,148,148,1)",
		minHeight: 80,
		marginBottom: 10,
		width: "100%",
		display: "flex",
		alignItems: "center",
	},
	mainContainerDisabled: {
		backgroundColor: "#7e95a7",
		color: "#fff",
		padding: 10,
		borderRadius: "4px",
		border: "1px solid #7e95a7",
		boxShadow: "0px 9px 20px -23px rgba(148,148,148,1)",
		minHeight: 80,
		marginBottom: 10,
		width: "100%",
		display: "flex",
		alignItems: "center",
	},
	mainDEContainer: {
		backgroundColor: "rgb(214, 43, 57)",
	},
	patientNoInfo: {
		fontStyle: "italic",
	},
};

const PatientSection = ({
	data,
	mode,
	isMobile,
	t,
	generalParameters,
	userIsSecretary,
	patientAddress,
	openContactModal,
	openEditPatient,
	openSidebar,
	editPatient,
	hideSidebar,
	dualScreen,
	openGranteeModal,
	submitChangePatientModal,
	newPatient,
	mysecuCheck,
	dkvCheck,
	dkvSyncing,
	isThemeHospital,
	getMpiPatientByMatricule,
}) => {
	const isDepotExpressPatient = +data.patient.id === +process.env.REACT_APP_USER_TO_CHANGE;
	const isFastlinePatient = data.patient.first_name === "Register" && data.patient.birth_name === "Line";
	const hasScans = data.prescriptions.some((p) => p.scans && p.scans.length > 0);
	const [changePatientModalOpen, setChangePatientModalOpen] = useState(false);
	const [managePatientModalOpen, setManagePatientModalOpen] = useState(
		isDepotExpressPatient && isFastlinePatient && !data.isDone && !isThemeHospital && !isMobile() && hasScans
	);
	const [mpiPatient, setMpiPatient] = useState(null);

	const mySecucheckIcon = () => (
		<Popup
			basic
			content={
				<div>
					<Header as="h5">
						Vérification MySecu - {mysecuCheck && mysecuCheck.patient && mysecuCheck.patient.is_affiliated && "Affilié"}
						{mysecuCheck && mysecuCheck.patient && !mysecuCheck.patient.is_affiliated && "Non affilié"}
						{mysecuCheck && mysecuCheck.error && "Erreur rencontrée"}
						{!mysecuCheck && "Non vérifié"}
					</Header>
					{mysecuCheck && !mysecuCheck.error && !mysecuCheck.errors && <span>Droit CNS ouvert</span>}
					{mysecuCheck && mysecuCheck.error && <span>Erreur rencontrée : {mysecuCheck.error}</span>}
					{mysecuCheck && mysecuCheck.errors && mysecuCheck.errors.map((e, index) => <Label key={`error-${index}`}>{e}</Label>)}
					{!mysecuCheck && <span>L'information MySecu n'a pas été récupérée</span>}
				</div>
			}
			trigger={
				<span>
					{mysecuCheck && mysecuCheck.patient && mysecuCheck.patient.is_affiliated && (
						<Label circular color="green" size="mini">
							<Icon name="user outline" style={{ margin: "1px" }} />
						</Label>
					)}
					{mysecuCheck && mysecuCheck.patient && !mysecuCheck.patient.is_affiliated && (
						<Label circular color="red" size="mini">
							<Icon name="user times" style={{ margin: "1px" }} />
						</Label>
					)}

					{mysecuCheck && !mysecuCheck.patient && mysecuCheck.error && (
						<Label circular color="black" size="mini">
							<Icon name="warning sign" style={{ margin: "1px" }} />
						</Label>
					)}
					{!mysecuCheck && (
						<Label circular size="mini">
							<Icon name="question" style={{ margin: "1px" }} />
						</Label>
					)}
				</span>
			}
		/>
	);

	const dkvCheckIcon = () => (
		<Popup
			basic
			on="click"
			pinned
			content={
				<div>
					<Header as="h5">
						Vérification DKV -{" "}
						{dkvCheck &&
							dkvCheck.length > 0 &&
							dkvCheck.some((c) => c.insurance_key === "dkv") &&
							dkvCheck?.some((c) => c.response.rates[0].rate_in_percent !== 0) &&
							"Affilié"}
						{dkvCheck && !dkvCheck.some((c) => c.insurance_key === "dkv") && "Non affilié"}
						{dkvCheck &&
							dkvCheck.some((c) => c.insurance_key === "dkv") &&
							!dkvCheck?.some((c) => c.response.rates[0].rate_in_percent !== 0) &&
							"Affilié mais pas d'intervention sur les prélèvements"}
						{dkvSyncing && "Synchronisation"}
					</Header>

					{dkvCheck &&
						dkvCheck.length > 0 &&
						dkvCheck
							.find((c) => c.insurance_key === "dkv")
							.response.rates.map((r) => (
								<div key={`rate-${r.cns_code}`} style={{ fontSize: "0.8em" }}>
									{r.cns_code} - {r.rate_in_percent * 100}%
								</div>
							))}
				</div>
			}
			trigger={
				<span>
					{!dkvSyncing &&
						dkvCheck &&
						dkvCheck.length > 0 &&
						dkvCheck.some((c) => c.insurance_key === "dkv") &&
						dkvCheck?.some((c) => c.response.rates[0].rate_in_percent !== 0) && (
							<Label circular color="green" size="mini" style={{ marginLeft: "5px" }}>
								<Icon name="check" style={{ margin: "1px" }} />
							</Label>
						)}
					{!dkvSyncing && dkvCheck && !dkvCheck.some((c) => c.insurance_key === "dkv") && (
						<Label circular color="red" size="mini" style={{ marginLeft: "5px" }}>
							<Icon name="question circle" style={{ margin: "1px" }} />
						</Label>
					)}
					{!dkvSyncing &&
						dkvCheck &&
						dkvCheck.some((c) => c.insurance_key === "dkv") &&
						dkvCheck.some((c) => c.response.rates[0].rate_in_percent === 0) && (
							<Label circular color="grey" size="mini" style={{ marginLeft: "5px" }}>
								<Icon name="check" style={{ margin: "1px" }} />
							</Label>
						)}
					{dkvSyncing && (
						<Label circular color="yellow" size="mini" style={{ marginLeft: "5px" }}>
							<Loader active inline size="mini" />
							<label style={{ marginLeft: "5px" }}>Synchronisation</label>
						</Label>
					)}
				</span>
			}
		/>
	);

	const searchByMatricule = (cns) => {
		getMpiPatientByMatricule(cns).then(async (resMpi) => {
			if (resMpi.payload && resMpi.payload.data && resMpi.payload.data.length > 0) {
				setMpiPatient(resMpi.payload.data[0]);
			} else toast.warn("Ce patient n'est pas dans l'annuaire national des patients.");
		});
	};

	return (
		<MainButtonsContainer mode={mode}>
			<Grid.Row
				style={
					isDepotExpressPatient || isFastlinePatient
						? { ...styles.mainDEContainer }
						: !data.isNurseHelp
						? { ...styles.mainContainer }
						: { ...styles.mainContainerDisabled }
				}
				className={isMobile() ? "mainButtonsGreenContainerMobile" : ""}
			>
				{isDepotExpressPatient && !data.isDone && !isThemeHospital && !isMobile() && (
					<Grid.Column mobile={16} tablet={16} computer={16}>
						<Grid style={{ margin: isMobile() ? 0 : "-1em" }}>
							<Grid.Row style={{ display: "flex", justifyContent: "center" }}>
								<WhiteButtonEditBloc
									text="Dépôt express : Sélectionner un patient pour ce dossier"
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										setManagePatientModalOpen(true);
									}}
								/>
							</Grid.Row>
						</Grid>
					</Grid.Column>
				)}
				{isFastlinePatient && !data.isDone && !isThemeHospital && !isMobile() && (
					<Grid.Column mobile={16} tablet={16} computer={16}>
						<Grid style={{ margin: isMobile() ? 0 : "-1em" }}>
							<Grid.Row style={{ display: "flex", justifyContent: "center" }}>
								<WhiteButtonEditBloc
									text="Fast Line Register : Sélectionner un patient pour ce dossier"
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										setManagePatientModalOpen(true);
									}}
								/>
							</Grid.Row>
						</Grid>
					</Grid.Column>
				)}

				{!isDepotExpressPatient && !isFastlinePatient && (
					<Grid.Column mobile={16} tablet={16} computer={16}>
						<Grid style={{ margin: isMobile() ? 0 : "-1em" }}>
							<Grid.Row>
								{data.isNurseHelp && (
									<Grid.Column mobile={16} tablet={16} computer={16} style={{ padding: 0, marginBottom: "1em" }}>
										<Message warning size="small">
											{t("folderManager.patientDataNotEditable")}
										</Message>
									</Grid.Column>
								)}
								<Grid.Column mobile={16} tablet={8} computer={8} style={{ paddingLeft: 0, marginBottom: "1em" }}>
									<b style={{ cursor: "pointer" }} onClick={() => openContactModal(openEditPatient)}>
										{data.patient.litigation && (
											<Popup trigger={<Icon name="podcast" color="yellow" />} content="Patient au contentieux" size="mini" />
										)}
										{displayGender(data.patient, generalParameters.data)} {displayName(data.patient)}
										<Icon name="zoom-in" style={{ paddingLeft: "5px" }} />
									</b>
								</Grid.Column>

								<Grid.Column mobile={8} tablet={4} computer={4} style={{ marginBottom: "1em" }}>
									{!data.isNurseHelp && (
										<WhiteButtonEditBloc
											text={data.isDone ? (isMobile() ? "..." : t("folderManager.moreDetails")) : t("folderManager.edit")}
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												openSidebar(
													<EditPatient
														patient={data.patient}
														prescriptions={data.prescriptions}
														onSubmit={editPatient}
														hideSidebar={hideSidebar}
														disabled={data.isDone}
														condensedDisplay={mode === "future" || mode === "validate"}
														dualScreen={dualScreen}
														hideOnSubmit={userIsSecretary ? false : true}
													/>
												);
											}}
										/>
									)}
								</Grid.Column>

								<Grid.Column
									mobile={8}
									tablet={4}
									computer={4}
									style={{
										marginBottom: "1em",
										display: "flex",
										justifyContent: "flex-end",
									}}
								>
									{!data.isDone && !data.isNurseHelp && !isMobile() && !isThemeHospital && (
										<WhiteButtonEditBloc
											text={t("folderManager.changePatient")}
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												setChangePatientModalOpen(true);
											}}
										/>
									)}
								</Grid.Column>

								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 8}
									computer={6}
									style={{ padding: "0" }}
								>
									<ContainerField
										field={data.patient.birth_name || t("folderManager.birthNameUnknown")}
										icon={<Icon name="child" />}
										onClick={openContactModal}
										useButton={false}
										style={{ cursor: "zoom-in" }}
										textFieldStyle={data.patient.birth_name ? {} : styles.patientNoInfo}
										label=""
									/>
								</Grid.Column>

								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 7}
									computer={5}
									style={{ padding: "0" }}
								>
									<div style={{ display: "flex", alignItems: "baseline" }}>
										<ContainerField
											field={(data.patient.cns || t("folderManager.cnsUnknown")).concat(
												data.patient.specialRegime ? "  -  " + data.patient.specialRegime.acronym : t("folderManager.regimeUnknown")
											)}
											icon={<Icon name="id card" />}
											textFieldStyle={data.patient.cns ? {} : styles.patientNoInfo}
											label=""
											style={{ paddingRight: "3px" }}
										/>
										{data.patient.specialRegime &&
											["1", "11", "2", "3", "4", "5", "6", "7", "999"].includes(data.patient.specialRegime.geslab_id) &&
											new RegExp("^[0-9]{13}$").test(data.patient.cns) &&
											mySecucheckIcon()}
									</div>
								</Grid.Column>
								{!isMobile() && (
									<Grid.Column
										mobile={8}
										tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 4 : 1}
										computer={5}
										style={{ fontWeight: "bold", padding: "0" }}
									>
										{data.patient.grantees && data.patient.grantees.length > 0 && (
											<ContainerField
												onClick={openGranteeModal}
												useButton={false}
												style={{ cursor: "zoom-in" }}
												label={
													<>
														<span>{t("folderManager.accessResult")} </span> <Icon name="zoom-in" style={{ paddingLeft: "5px" }} />
													</>
												}
											/>
										)}
									</Grid.Column>
								)}

								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 8}
									computer={6}
									style={{ padding: "0" }}
								>
									<ContainerField
										field={
											data.patient.birth_date
												? t("folderManager.birthPatient", {
														date: moment(data.patient.birth_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT),
														age: moment().diff(data.patient.birth_date, "years"),
												  })
												: t("folderManager.birthUnknown")
										}
										icon={<Icon name="birthday" />}
										onClick={openContactModal}
										useButton={false}
										style={{ cursor: "zoom-in" }}
										label=""
										textFieldStyle={data.patient.birth_date ? {} : styles.patientNoInfo}
									/>
								</Grid.Column>

								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 7}
									computer={5}
									style={{ padding: "0" }}
								>
									<ContainerField
										field={
											data.patient.mobile_phone && checkPrefixePhoneNumer(data.patient.mobile_phone)
												? `${formatPhoneNumberToInternational(data.patient.mobile_phone)}${
														data.patient.mobile_phone_is_relative ? t("folderManager.near") : ""
												  }${data.patient.mobile_phone_comment ? ` - ${data.patient.mobile_phone_comment}` : ""}`
												: t("folderManager.phoneUnknown")
										}
										onClick={openContactModal}
										useButton={false}
										style={{ cursor: "zoom-in" }}
										icon={<Icon name="mobile alternate" />}
										label=""
										textFieldStyle={data.patient.mobile_phone ? {} : styles.patientNoInfo}
									/>
								</Grid.Column>
								{!isMobile() && (
									<Grid.Column
										mobile={8}
										tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 4 : 1}
										computer={5}
										style={{ padding: "0" }}
									>
										{data.patient.grantees && data.patient.grantees.length > 0 && (
											<ContainerField
												onClick={openGranteeModal}
												useButton={false}
												style={{ cursor: "zoom-in" }}
												field={
													<span>
														{data.patient.grantees[0].grantee?.last_name?.toUpperCase() ??
															data.patient.grantees[0].grantee?.birth_name?.toUpperCase()}{" "}
														{capitalize(data.patient.grantees[0].grantee?.first_name)} ({data.patient.grantees[0].relation ?? ""})
													</span>
												}
												label=""
											/>
										)}
									</Grid.Column>
								)}
								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 8}
									computer={6}
									style={{ padding: "0" }}
								>
									<ContainerField
										field={
											data.patient.email
												? `${data.patient.email}${data.patient.email_comment ? ` - ${data.patient.email_comment}` : ""}`
												: t("folderManager.mailUnknown")
										}
										onClick={openContactModal}
										useButton={false}
										style={{ cursor: "zoom-in" }}
										icon={<Icon name="mail" />}
										label=""
										textFieldStyle={data.patient.email ? {} : styles.patientNoInfo}
									/>
								</Grid.Column>
								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 7}
									computer={5}
									style={{ padding: "0" }}
								>
									<ContainerField
										field={
											data.patient.phone && checkPrefixePhoneNumer(data.patient.phone)
												? `${formatPhoneNumberToInternational(data.patient.phone)}${
														data.patient.phone_comment ? ` - ${data.patient.phone_comment}` : ""
												  }`
												: t("folderManager.homePhoneUnknown")
										}
										onClick={openContactModal}
										useButton={false}
										style={{ cursor: "zoom-in" }}
										icon={<Icon name="phone" />}
										label=""
										textFieldStyle={data.patient.mobile_phone || data.patient.phone ? {} : styles.patientNoInfo}
									/>
								</Grid.Column>
								{!isMobile() && (
									<Grid.Column
										mobile={8}
										tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 4 : 1}
										computer={5}
										style={{ padding: "0" }}
									>
										{data.patient.grantees && data.patient.grantees.filter((g) => g.grantee).length > 1 && (
											<ContainerField
												onClick={openGranteeModal}
												useButton={false}
												style={{ cursor: "zoom-in" }}
												field={
													<span>
														{data.patient.grantees[1].grantee?.last_name?.toUpperCase() ??
															data.patient.grantees[1].grantee?.birth_name?.toUpperCase()}{" "}
														{capitalize(data.patient.grantees[1].grantee?.first_name)} ({data.patient.grantees[1].relation ?? ""})
													</span>
												}
												label=""
											/>
										)}
									</Grid.Column>
								)}
								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 8}
									computer={6}
									style={{ padding: "0" }}
								>
									<ContainerField
										field={!!patientAddress && patientAddress !== "" ? patientAddress : t("folderManager.addrUnknown")}
										icon={<Icon name="home" />}
										textFieldStyle={!!patientAddress && patientAddress !== "" ? {} : styles.patientNoInfo}
										label=""
									/>
								</Grid.Column>

								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 7}
									computer={5}
									style={{ padding: "0" }}
								>
									<ContainerField
										field={
											<span>
												{data.patient.patientInsurances && data.patient.patientInsurances[0]
													? `${data.patient.patientInsurances[0]?.insurance?.name ?? ""}  ${data.patient.patientInsurances[0]?.number ?? ""}`
													: t("folderManager.mutualUnknown")}
												{data.patient.patientInsurances && data.patient.patientInsurances.some((i) => i.insurance.id === 4) && dkvCheckIcon()}
											</span>
										}
										icon={<Icon name="plus" />}
										textFieldStyle={data.patient.patientInsurances && data.patient.patientInsurances[0] ? {} : styles.patientNoInfo}
										label=""
									/>
								</Grid.Column>
								{!isMobile() && (
									<Grid.Column
										mobile={8}
										tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 4 : 1}
										computer={5}
										style={{ padding: "0" }}
									>
										{data.patient.grantees && data.patient.grantees.length > 2 && (
											<ContainerField
												onClick={openGranteeModal}
												useButton={false}
												style={{ cursor: "zoom-in" }}
												field={<span> ... et {data.patient.grantees.length - 2} autre.s proche.s</span>}
												label=""
											/>
										)}
									</Grid.Column>
								)}

								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 8}
									computer={6}
									style={{ padding: "0" }}
								>
									{data.patient.patientInsurances && data.patient.patientInsurances[1] && (
										<ContainerField
											field={
												data.patient.patientInsurances[1]
													? `${data.patient.patientInsurances[1]?.insurance?.name ?? ""} - ${data.patient.patientInsurances[1]?.number ?? ""}`
													: t("folderManager.mutualUnknown")
											}
											icon={<Icon name="plus" />}
											textFieldStyle={data.patient.patientInsurances[1] ? {} : styles.patientNoInfo}
											label=""
										/>
									)}
								</Grid.Column>

								<Grid.Column
									mobile={8}
									tablet={data.patient.grantees && data.patient.grantees.length > 0 ? 6 : 8}
									computer={6}
									style={{ padding: "0" }}
								>
									<ContainerField
										field={data.patient.mylab_is_active ? t("folderManager.activeMyLab") : t("folderManager.notActiveMyLab")}
										icon={<Icon name="heart" />}
										label=""
									/>
								</Grid.Column>

								<Grid.Column mobile={8} tablet={8} computer={5} style={{ padding: "0" }}>
									{data.patient.dsp_status && (
										<ContainerField
											field={
												data.patient.dsp_status === null
													? t("folderManager.dspNotAvailable")
													: data.patient.dsp_status === "open" || data.patient.dsp_status === "created"
													? t("folderManager.dspNotOpen", { dsp: data.patient.dsp_id ?? "" })
													: t("folderManager.dspNotOpen")
											}
											icon={<Icon name="folder" />}
											label=""
										/>
									)}
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Grid.Column>
				)}
			</Grid.Row>
			<ChangePatientModal
				open={changePatientModalOpen}
				close={() => setChangePatientModalOpen(false)}
				submit={submitChangePatientModal}
				newPatient={() => openSidebar(<AddPatient filter={null} hideSidebar={hideSidebar} onSubmit={newPatient} />)}
				files={data.prescriptions.flatMap((p) => p.scans)}
				t={t}
			/>
			<ManagePatientExpressModal
				open={managePatientModalOpen}
				close={() => setManagePatientModalOpen(false)}
				submit={submitChangePatientModal}
				files={data.prescriptions.flatMap((p) => p.scans)}
				searchByMatricule={searchByMatricule}
				mpiPatient={mpiPatient}
				initMpiPatient={() => setMpiPatient(null)}
			/>
		</MainButtonsContainer>
	);
};
export default PatientSection;
